import React from "react";
import { Col, Row, Typography } from "antd";
import Card from "@/components/Card";

import Loader from "./Loader";
import Taker from "./Taker";
import { useRootSelector } from "@/infrastructure/hooks";
import { AppSel } from "@/features/applications";

import styles from "./styles.less";
import { useFirestoreConnect } from "react-redux-firebase";

export default () => {
  const userId = useRootSelector(AppSel.userId);
  const isSuperuser = useRootSelector(AppSel.isSuperuser);
  useFirestoreConnect([{ collection: "backtest_snapshot" }]);

  if (userId.length === 0 || !isSuperuser) {
    return (
      <Row className={styles.content} justify={"center"}>
        <Typography.Title level={4} style={{ color: "white" }}>
          Please login to access snapshot feature
        </Typography.Title>
      </Row>
    );
  }

  return (
    <Row className={styles.content} gutter={[16, 8]}>
      <Col span={24}>
        <Card title={"Save Result"}>
          <Typography.Paragraph>
            Save current setup & results.
          </Typography.Paragraph>
          <Taker />
        </Card>
      </Col>
      <Col span={24}>
        <Card title={"Load Result"}>
          <Typography.Paragraph>
            Load list of available results & setups.
          </Typography.Paragraph>
          <Loader />
        </Card>
      </Col>
    </Row>
  );
};
